<template>
  <form class="card rounded-top" @submit.prevent="saveSchedule">
    <div class="row card-body">
      <div v-if="!feeName" class="form-group col-12">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div v-if="!feeName" class="form-group col-12">
        <w-textarea :model="$schema.description" :title="$t($schema.description.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <form-datepicker :model="$schema.start" :title="$t($schema.start.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <form-datepicker :model="$schema.end" :title="$t($schema.end.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <schedules-form
          :containerSchema="$schema.schedules"
          :entityType="entityType"
          :entityId="entityId"
          :scheduleContainerId="id"
        />
      </div>

      <div class="col-12  text-right card-actions">
        <button class="btn btn-dark btn-lg rounded-pill" @click.prevent="$emit('cancel')">
          {{ $t('buttons.cancel') }}
        </button>

        <button type="submit" class="btn btn-smart btn-lg rounded-pill">{{ $t('buttons.save') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/scheduleContainer.schema';
import SchedulesForm from './SchedulesForm';

const emptyData = () => ({
  name: '',
  description: '',
  start: '',
  end: '',
  entityId: '',
  entityType: '',
  schedules: []
});

const messages = {
  added: 'messages.schedule.added',
  addError: 'messages.schedule.addError',
  formError: 'messages.schedule.formError',
  updated: 'messages.schedule.updated',
  updateError: 'messages.schedule.updateError'
};

// @vuese
// Formularz do edycji/dodawania harmonogramów
// @group Schedule
export default {
  name: 'ScheduleContainerForm',
  schema,
  mixins: [formViewMixin('schedule', messages, emptyData)],
  components: { SchedulesForm },
  props: {
    // Typ encji
    entityType: {
      required: true,
      type: String
    },
    // Rodzaj encji
    entityId: {
      required: true,
      type: String
    },
    // Dane składki
    feeName: {
      required: false,
      type: String
    }
  },
  methods: {
    // @vuese
    // Zapisuje harmonogram
    // @group Schedule
    saveSchedule() {
      if (this.feeName) {
        this.$schema.name.$model = this.feeName;
      }
      this.$schema.entityType.$model = this.entityType;
      this.$schema.entityId.$model = this.entityId;
      this.save();
    }
  }
};
</script>
